import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import DiagramService from '@/app/services/diagram-data-service'
import debounce from 'lodash/debounce'
import { KeywordType } from '@/diagrams/models/keyword-type'
import { Debouceable } from '@/app/types/debouncable'

@Component
export default class Keywords extends Vue {

  @Prop({ required: true })
  private value!: string[]

  @Prop({ required: true })
  private type!: KeywordType

  @Prop({ default: false})
  private archived!: boolean

  private items: any[] = []
  private model: any[] = []
  private search = ''
  private loading: boolean = false

  // private tooltiptext:string = "tooltiptext"

  private debounced: Debouceable = null

  @Watch('value', { deep: true })
  private valueChanged(val: string[], old: string[]) {
    this.loadSelection()
  }

  private loadSelection() {
    if (this.value) {
      this.model = this.value.map(this.normalizeInput)
    }
  }

  private async getKeywordsDebounced() {
    if (this.debounced) {
      this.debounced.cancel()
    }

    this.debounced = debounce(async () => this.getKeywords(this.search), 500)
    this.debounced()
  }

  private async getKeywords(text: string = '') {
    this.loading = true
    const keywords = await DiagramService.getKeywords(this.type, text)
    this.items = []
    this.items.push({ id: 'create' })
    this.items.push({ divider: true })
    this.items.push({ header: 'Vervollständigung' })
    this.items.push(...keywords)
    // this.items.push({ header: 'Häufig verwendete Schlüsselwörter' })
    this.loading = false
  }

  private onInput(val: any) {
    this.model = val
      .filter((v: any) => v.id !== 'create')
      .map(this.normalizeInput)
  }

  private onChange() {
    this.$emit('input', this.model.map(this.normalizeOutput))
    this.search = ''
  }

  private normalizeInput(v: any) {
    if (typeof v === 'string') {
      return { name: v }
    }
    return v
  }

  private normalizeOutput(v: any) {
    if (typeof v === 'object') {
      return v.name
    }
    return v
  }

  private highlight(v: string) {
    const regex = new RegExp(`(${this.search})`, 'ig')
    return v.replace(regex, '<strong>$1</strong>')
  }

  private async created() {
    // await this.getKeywords()
  }

  private mounted() {
    this.loadSelection()
  }
}
